import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";
import { NavLink } from "react-router-dom";

export interface IDownloadBankFTPRequest {
    bankCode: string;
    date: string; // ISO string (e.g. "2025-09-17T10:45:54.982Z")
    bankName: string;
}

export interface IDownloadBankFTPResponse {
    blob: Blob;
    fileName: string;
}

async function downloadBankFTP(
    data: IDownloadBankFTPRequest
): Promise<IDownloadBankFTPResponse> {
    try {
        const response = await axiosInstance.post(
            "/Reconciliation/DownloadFtpBankFile",
            {
                bankCode: data.bankCode,
                date: data.date,
            },
            { responseType: "blob" } // get raw file
        );

        console.log('headers', response)

        const contentDisposition = response.headers["content-disposition"];
        let fileName = data.bankCode + "_" + data.bankName + "_" + data.date + ".zip";

        if (contentDisposition) {
            const match =
                contentDisposition.match(/filename\*?=(?:UTF-8''|)([^;\n]*)/) ||
                contentDisposition.match(/filename="?([^"]+)"?/);

            if (match?.[1]) {
                fileName = decodeURIComponent(match[1]);
            }
        }

        return { blob: response.data, fileName };
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any)?.error || ex;
    }
}

export function useDownloadBankFTP() {
    return useMutation<IDownloadBankFTPResponse, Error, IDownloadBankFTPRequest>(
        (variables) => downloadBankFTP(variables)
    );
}
